import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useLoaders = (): IGlobalStore['loaders'] => {
  return useSelector((store: IReducerStore) => store.global.loaders);
};
